export {
  DigitalCredentialsRequest,
  RegisterCredentialsOptions,
  SendErrorResponseOptions,
  SendResponseOptions,
  DigitalCredentialsApiMatcher,
} from './DigitalCredentialsApi.types'
export {
  registerCredentials,
  sendErrorResponse,
  sendResponse,
  isGetCredentialActivity,
} from './api'
